<template>
  <div class="avatar-stat-page">
    <div class="oper-bar">
      <div class="select-wrap">
        <span>选择区服：</span>
        <el-select v-model="serverName" placeholder="请选择区服" @change="loadData" style="width:240px">
          <el-option
            v-for="server in serverList"
            :key="server"
            :label="server"
            :value="server"
          />
        </el-select>
      </div>
      <span v-if="serverName">当前查询区服：<strong>{{ serverName }}</strong></span>
      <el-button type="primary" @click="loadData" :loading="loading">刷新数据</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      v-loading="loading"
      style="width: 100%; margin-top:16px"
    >
      <el-table-column label="头像ID" prop="avatarId" />
      <el-table-column label="累计使用时长(秒)" prop="totalUseSeconds" />
      <el-table-column label="累计使用时长(时分秒)">
        <template #default="{ row }">
          {{ formatSecond(row.totalUseSeconds) }}
        </template>
      </el-table-column>
      <el-table-column label="切换使用总次数" prop="useCount" />
      <el-table-column label="独立玩家数量" prop="distinctUserCount" />
    </el-table>
  </div>
</template>

<script setup>
import { GAME_API } from '@/utils/apiBase';
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const tableData = ref([])
const loading = ref(false)
const serverName = ref('')
const serverList = ref([])

// 秒转 时:分:秒
const formatSecond = (secVal) => {
  const sec = Number(secVal || 0)
  const h = Math.floor(sec / 3600)
  const m = Math.floor((sec % 3600) / 60)
  const s = sec % 60
  return `${h}时${m}分${s}秒`
}

// 加载区服列表
const loadServerList = async () => {
  try {
    const token = sessionStorage.getItem('token')
    const url = `${GAME_API}/api/Avatar/GetServerNameList`
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    // 根据你上一条返回格式，如果直接数组：
    if (Array.isArray(res.data)) {
      serverList.value = res.data
    } else if (res.data.Data && Array.isArray(res.data.Data)) {
      serverList.value = res.data.Data
    }
  } catch (err) {
    console.error('获取头像模块区服列表失败', err)
  }
}

// 请求头像统计接口
const loadData = async () => {
  if (!serverName.value) {
    tableData.value = []
    return
  }
  loading.value = true
  try {
    const token = sessionStorage.getItem('token')
    const url = `${GAME_API}/api/Avatar/GetAllAvatarList`
    const res = await axios.get(url, {
      params: {
        serverName: serverName.value
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    // ✅ 重点：你接口 res.data 直接就是数组，不需要取 .Data
    if (Array.isArray(res.data)) {
      tableData.value = res.data
    } else {
      tableData.value = []
    }
  } catch (err) {
    console.error('获取头像统计失败：', err)
    alert('数据加载失败，请稍后重试')
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  await loadServerList()
  if (route.query.serverName) {
    serverName.value = route.query.serverName
  }
})
</script>

<style scoped>
.oper-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.select-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
